import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconCaretDown } from '@redteclab/icons'

import { Button } from 'base-ui'

import { useGlobalConfigContext } from '../../../../../global-config'
import { urlResolverGetRedeemPaperPrescription } from '../../../../../url-handling'
import {
  erxBonusLandingPageTextAccent,
  erxBonusLandingPageTextBreak,
} from '../../../../components/ErxBonusLandingPageTranslationValues'
import { HOW_BONUS_CALCULATED_SECTION_ID } from '../ErxBonusLandingPageHowBonusIsCalculated/ErxBonusLandingPageHowBonusIsCalculated'

export const ErxBonusLandingPageHeroActions: FC = () => {
  const globalConfig = useGlobalConfigContext()

  return (
    <div className="flex items-center justify-center bg-light-primary-medium px-4 pt-4 tablet:-mt-3 tablet:shrink-0 tablet:grow-0 tablet:basis-2/5 tablet:bg-light-brand-high">
      <div className="flex flex-col gap-9 tablet:gap-4">
        <div>
          <h1 className="text-2xl font-medium tablet:text-4xl">
            <FormattedMessage
              id="deErx.oldBonus.heroHeader.eRezept.title"
              values={{
                accentuate: erxBonusLandingPageTextAccent,
                break: erxBonusLandingPageTextBreak,
              }}
            />
          </h1>
        </div>
        <div className="mb-9 flex flex-col gap-4 tablet:mb-0 tablet:flex-row">
          <Button<'a'>
            className="w-full"
            href={`#${HOW_BONUS_CALCULATED_SECTION_ID}`}
            slots={{ root: 'a' }}
            startIcon={<IconCaretDown />}
          >
            <FormattedMessage id="actiontile.cta.more.information" />
          </Button>
          <Button<'a'>
            className="w-full"
            href={urlResolverGetRedeemPaperPrescription(globalConfig)}
            slots={{ root: 'a' }}
            variant="outlined"
          >
            <FormattedMessage id="deErx.oldBonus.heroHeader.eRezept.btn" />
          </Button>
        </div>
      </div>
    </div>
  )
}
